var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"pills":""}},[_c('b-tab',{attrs:{"title":"Supplier","active":""}},[_c('index')],1),_c('b-tab',{attrs:{"title":"Customer"}},[_c('indexCustomer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }